export const YoutubeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="17" viewBox="0 0 21 17" fill="none">
    <path
      d="M15.5 0.5H5.5C2.5 0.5 0.5 2.5 0.5 5.5V11.5C0.5 14.5 2.5 16.5 5.5 16.5H15.5C18.5 16.5 20.5 14.5 20.5 11.5V5.5C20.5 2.5 18.5 0.5 15.5 0.5ZM12.39 9.53L9.92 11.01C8.92 11.61 8.09998 11.15 8.09998 9.98V7.01C8.09998 5.84001 8.92 5.38001 9.92 5.98001L12.39 7.46C13.34 8.04 13.34 8.96 12.39 9.53Z"
      fill="#4A148C"
    />
  </svg>
);
